<template>
  <b-modal ref="modal" :hideFooter="true" size="md" title="Generate invoice" id="invoice-modal">

    <div class="row">
      <div class="col">
        <span class="text-strong">Invoice number</span>
        <div class="input-group invoice-number">
          <div class="input-group-prepend">
            <span class="input-group-text">DTR</span>
          </div>
          <input type="text" class="form-control" v-model="invoiceNumber" :disabled="generatingInvoice">
        </div>
        <span class="text-detail color-gray-500">Last number found: {{ last_invoice_number }}</span>
      </div>
      <div class="col">
        <span class="text-strong">Date</span>
        <date-picker
          class="text-center"
          @dateSelected="invoiceDate = $event"
          :dateFormat="'dd M yyyy'"
          :defaultDate="invoiceDate"
          @blur="$v.invoiceDate.$touch()"
        ></date-picker>
      </div>
    </div>

    <div class="heading-small mt-5">Exchange rates</div>
<!--    <small>{{ cacheValidUntil ? '(valid until: ' + cacheValidUntil.format('YYYY-MM-DD HH:mm') + ')': null }}</small>-->

    <div class="exchange-rates">
      <div class="rate">
        <div class="text-strong">GBP</div>
        <input type="number" class="form-control" v-model="exchangeRates[2]" @input="cacheModal">
      </div>
      <div class="rate">
        <div class="text-strong">USD</div>
        <input type="number" class="form-control" v-model="exchangeRates[3]" @input="cacheModal">
      </div>
      <div class="rate">
        <div class="text-strong">AUD</div>
        <input type="number" class="form-control" v-model="exchangeRates[4]" @input="cacheModal">
      </div>
    </div>

    <div class="generate-button-holder">
      <button class="btn btn-jet" @click="generateInvoice" v-if="!generatingInvoice" :disabled="!invoiceNumber">Generate</button>
      <button class="btn jet" v-if="generatingInvoice" :disabled="true">
        <i class="fa fa-sync fa-spin"></i>
      </button>
    </div>

  </b-modal>
</template>
<script>
  import bModal from 'bootstrap-vue/src/components/modal/modal'
  import DatePicker from '../../components/partials/Datepicker.vue'
  import moment from 'moment'

  export default {
    components: {
      bModal,
      DatePicker,
    },
    created() {

      this.$root.$on('Invoices::openInvoicingModal', (data) => {
        this.projects = data.projects
        this.startDate = data.startDate
        this.endDate = data.endDate
        this.invoiceNumber = data.last_invoice_number + 1
        this.last_invoice_number = data.last_invoice_number
        this.loadModalCache()
        this.invoiceDate = this.invoiceDate || moment(this.endDate).format('DD MMM YYYY')

        this.$refs.modal.show()
      })

    },
    data() {
      return {
        projects: null,
        startDate: null,
        endDate: null,
        invoiceNumber: null,
        generatingInvoice: false,
        invoiceDate: null,
        last_invoice_number: null,
        exchangeRates: {
          2: null,
          3: null,
          4: null,
        },
        cacheValidUntil: null,
      }
    },
    watch: {
      invoiceDate() {
        this.cacheModal()
      }
    },
    methods: {
      loadModalCache() {
        let cache = localStorage.getItem('modal_cache')
        if (cache) {
          cache = JSON.parse(cache)
          let validUntil = moment(cache.date).endOf('day')
          if (validUntil > moment()) {
            this.exchangeRates = cache.exchangeRates
            this.cacheValidUntil = validUntil
            this.invoiceDate = moment(cache.invoiceDate).format('DD MMM YYYY')
          }
        }
      },
      cacheModal() {
        let cache = {
          date: moment().toISOString(),
          exchangeRates: this.exchangeRates,
          invoiceDate: this.invoiceDate
        }

        localStorage.setItem('modal_cache', JSON.stringify(cache))

        return true
      },
      generateInvoice() {
        let data = {
          projects: _.map(this.projects, p => p.id),
          startDate: this.startDate,
          endDate: this.endDate,
          invoiceDate: this.invoiceDate,
          invoiceNumber: this.invoiceNumber,
          exchangeRates: this.exchangeRates,
        }

        this.axios.post('/invoices2/generate-invoices', data).then(response => {
          this.$root.$emit('Invoices::reloadIndexTables')
          this.$refs.modal.hide()
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/invoices2/InvoicingModal.vue